import { FieldTypes } from '../constants'
import {
  BooleanField,
  CheckboxField,
  DateField,
  EmailField,
  Field,
  FieldMap,
  PhoneField,
  TextField,
} from '../types'
import { emailField } from './shared'
import { addFieldRow, makeOptional } from './utils'

export const phoneField: Field = {
  // labels: [{ text: 'How can we get in touch with you?' }],
  type: FieldTypes.PHONE,
  placeholder: 'Phone Number',
}

export const dobField: DateField = {
  // labels: [{ text: 'What is your date of birth?' }],
  type: FieldTypes.DATE,
  placeholder: 'Date of Birth',
}
const fnameField: TextField = {
  labels: [{ text: 'What is your name?' }],
  type: FieldTypes.TEXT,
  placeholder: 'First Name',
}

const middleNameField: TextField = {
  type: FieldTypes.TEXT,
  placeholder: 'Middle Name',
  optional: true,
}

const lnameField: TextField = {
  type: FieldTypes.TEXT,
  placeholder: 'Last Name',
}

export const voicemailOkField: BooleanField = {
  type: FieldTypes.BOOLEAN,
  labels: [{ text: 'Is it ok to leave a voicemail?' }],
  placeholder: 'Voicemail OK?',
}

export const optIntoTextField: BooleanField = {
  type: FieldTypes.BOOLEAN,
  labels: [
    {
      text: 'Is it ok to send you text messages?',
    },
  ],
  placeholder: 'Text messages OK?',
}

export const nicknameField: Field = {
  // labels: [{ text: 'Do you have a nickname that you prefer?' }],
  type: FieldTypes.TEXT,
  placeholder: 'Nickname',
  optional: true,
}

const pronounsField: TextField = {
  type: FieldTypes.TEXT,
  placeholder: 'Pronouns',
  optional: true,
}

export const nameField: FieldMap = {
  name: 'What is your name?',
  children: {
    fname: fnameField,
    middleName: middleNameField,
    lname: lnameField,
    nickname: nicknameField,
    pronouns: pronounsField,
  },
}

export const patientField: FieldMap = {
  name: 'Patient',
  children: {
    fname: addFieldRow(fnameField, { index: 0, flex: 1 }),
    lname: addFieldRow(lnameField, { index: 0, flex: 1 }),
    nickname: addFieldRow(nicknameField, { index: 0, flex: 1 }),
    pronouns: addFieldRow(pronounsField, { index: 0, flex: 1 }),
    dob: addFieldRow(dobField, { index: 1, flex: 1 }),
    phone: addFieldRow(phoneField, { index: 1, flex: 1 }),
    voicemailOk: addFieldRow(voicemailOkField, { index: 2, flex: 1 }),
    textOk: addFieldRow(optIntoTextField, { index: 2, flex: 1 }),
  },
}

const simpleFnameField: TextField = {
  type: FieldTypes.TEXT,
  placeholder: 'First Name',
}

const simpleLnameField: TextField = {
  type: FieldTypes.TEXT,
  placeholder: 'Last Name',
}

const simplePhoneField: PhoneField = {
  ...phoneField,
  placeholder: 'Phone',
  optional: true,
  labels: undefined,
  hints: undefined,
}

const simpleDobField: DateField = {
  ...dobField,
  optional: true,
  hints: undefined,
  labels: undefined,
}

const simpleEmailField: EmailField = {
  ...emailField,
  placeholder: 'Email',
  optional: true,
  hints: undefined,
  labels: undefined,
}

const verifyEmailField: CheckboxField = {
  type: FieldTypes.CHECKBOX,
  placeholder: 'Email Verified',
  condition: v => !!v?.email,
  hints: [
    {
      text: 'For security reasons, the checkbox below should only be used if the patient is having issues verifying their email and you are sure of their identity',
    },
  ],
}

export const newPatientField: FieldMap = {
  name: 'New Patient',
  children: {
    fname: simpleFnameField,
    lname: simpleLnameField,
    nickname: nicknameField,
    email: simpleEmailField,
    verifyEmail: verifyEmailField,
    phone: simplePhoneField,
    dob: simpleDobField,
  },
}

export const newPatientReviewField: FieldMap = {
  name: 'New Patient',
  children: {
    fname: simpleFnameField,
    middleName: middleNameField,
    lname: simpleLnameField,
    dob: simpleDobField,
    email: simpleEmailField,
  },
}

export const newPatientConfirmField: FieldMap = {
  name: 'New Patient',
  children: {
    email: simpleEmailField,
    nickname: nicknameField,
    verifyEmail: verifyEmailField,
    phone: simplePhoneField,
    dob: simpleDobField,
  },
}

export const newPracticePatientField: FieldMap = {
  name: 'New Patient',
  children: {
    fname: simpleFnameField,
    lname: simpleLnameField,
    nickname: nicknameField,
    email: simpleEmailField,
    phone: simplePhoneField,
    dob: simpleDobField,
    messageToAdmins: {
      type: FieldTypes.TEXTAREA,
      placeholder: 'Message to Admins',
    },
  },
}

export const patientDropdownField: FieldMap = {
  name: 'Patient',
  children: {
    fname: fnameField,
    lname: lnameField,
    dob: dobField,
  },
}

export const maidenNameField: FieldMap = {
  name: 'Maiden Name',
  children: {
    fname: addFieldRow(makeOptional(simpleFnameField), { index: 0, flex: 1 }),
    middleName: addFieldRow(makeOptional(middleNameField), { index: 0, flex: 1 }),
    lname: addFieldRow(makeOptional(simpleLnameField), { index: 0, flex: 1 }),
  },
}
